import { Toast } from "primereact/toast";
import { useRef, useState } from "react";
import { Form } from "./Form";
import { Table } from "./Table";

export const ConsultantHotList = () => {
    const [modal, setModal] = useState({ singleData: {}, open: false } as { singleData: any, open: boolean });
    const [reload, setReload] = useState(false);

    const toast = useRef<Toast>(null);

    const onHide = () => {
        setModal({ singleData: {}, open: false });
        setReload(!reload);
    }

    return (
        <>
            <Form open={modal.open} singleData={modal.singleData} onHide={onHide} toast={toast} />
            <Table setModal={setModal} reload={reload} toast={toast} />
            <Toast ref={toast} />
        </>
    );
}